<template>
    <div style="width: 100%; height: 80vh;" class="border rounded d-flex flex-column align-items-center justify-content-center">
        <i class="fa-regular fa-map-location-dot fa-10x mb-4"></i>
        <p>Enter your postcode to populate map</p>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>